import { render } from "./ContentAccordination.vue?vue&type=template&id=17bea9a2&ts=true"
import script from "./ContentAccordination.vue?vue&type=script&lang=ts"
export * from "./ContentAccordination.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__